import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin( ScrollTrigger, ScrollToPlugin );

const stickySections = document.querySelectorAll( ".sticky-nav-section" );

stickySections.forEach( ( section ) => {
  const ball = section.querySelector( ".ball" );
  const navInner = section.querySelector( ".nav-inner" );
  const labelLinks = section.querySelectorAll( "ul li a" );
  const parentWidth = section.querySelector( "ul" ).getBoundingClientRect().width + 64;

  let isClicking = false;

  labelLinks.forEach( ( link, index ) => {
    link.addEventListener( "click", ( e ) => {
      e.preventDefault();

      isClicking = true;

      const amountTranslateX = ( parentWidth / labelLinks.length ) * index;
      gsap.to( ball, { x: amountTranslateX } );

      const targetId = link.getAttribute( "href" ).slice( 1 );
      const target = document.getElementById( targetId );
      if ( !target ) {
        isClicking = false;
        return;
      }

      const sectionHeight = target.offsetHeight;
      const offset = sectionHeight * 0.25;
      const fixedHeaderHeight = 80;

      const targetY = target.getBoundingClientRect().top + window.scrollY - offset - fixedHeaderHeight;

      gsap.to( window, {
        duration: 1,
        scrollTo: { y: targetY },
        ease: "power2.inOut",
        onComplete: () => {
          ScrollTrigger.update();
          isClicking = false;
        },
      } );
    } );
  } );

  ScrollTrigger.create( {
    trigger: section,
    start: "top -12.5%",
    end: "bottom top",
    scrub: true,
    onUpdate: ( self ) => {
      if ( isClicking ) return;

      const progress = self.progress;
      let amountTranslateX = progress * parentWidth;
      amountTranslateX = Math.min( amountTranslateX, parentWidth - 310 );
      gsap.to( ball, {
        x: amountTranslateX,
        overwrite: "auto",
        duration: 0.3,
        ease: "power2.out",
      } );
    },
  } );


  if ( window.innerWidth < 768 && navInner ) {
    gsap.to( navInner, {
      scrollTrigger: {
        trigger: section,
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
      x: "-35%", // adjust based on how far you want to scroll
      ease: "none",
    } );
  }

} );